import { Radio } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import './availabilityDuration.css';
import { noop } from 'lodash';

const start_times = {
  immediately: 0,
  custom_time: 1
};

const AvailabilityDuration = ({ checked, handleChange, onInpBlur = noop }) => {
  let value;
  if (checked !== null && checked !== undefined) {
    value = checked === 0 ? 0 : 1;
  }

  /**
   * @Peter Function Idea gotten from:
   * https://stackoverflow.com/questions/32936352/html-number-input-min-and-max-not-working-properly
   * @param {*} el
   *
   */
  const enforceMinMax = (el) => {
    if (el.target.value !== '') {
      if (parseInt(el.target.value) < parseInt(el.target.min)) {
        el.target.value = el.target.min;
      }
      if (parseInt(el.target.value) > parseInt(el.target.max)) {
        el.target.value = el.target.max;
      }
    }
    /* Passing false on Onchange handler to avoid making API call on each input change in Onboarding page */
    handleChange(el.target.value, false);
  };

  return (
    <Radio.Group value={value} onChange={(e) => handleChange(e.target.value)}>
      <Radio value={start_times.immediately} style={{ marginBottom: '8px' }}>Immediately</Radio>
      <Radio className="duration-input" value={start_times.custom_time}>In <input onKeyUp={enforceMinMax} max="10" type="number" className='start-time-input ant-input' disabled={value !== start_times.custom_time} min={1} onBlur={() => onInpBlur()} defaultValue={checked > 0 ? checked : start_times.custom_time} /> {checked > 1 ? 'weeks' : 'week'} after I get the offer</Radio>
    </Radio.Group>
  );
};

AvailabilityDuration.propTypes = {
  checked: PropTypes.number,
  handleChange: PropTypes.func,
  onInpBlur: PropTypes.func
};

export default AvailabilityDuration;
